import { fetch } from '@atlassian/eoc-fetch';
export const getTeamPolicies = teamId => {
  return fetch(`/v1/teams/${teamId}/policies?type=alert`);
};
export const getGlobalPolicies = teamId => {
  if (teamId) {
    return fetch(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
  }
  return fetch(`/v1/alerts/policies`);
};
export const getNotificationPolicies = teamId => {
  return fetch(`/v1/teams/${teamId}/policies?type=notification`);
};
export const getPolicyMaintenanceRights = () => {
  return fetch(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
export const updateUIPreferenceEndpoint = ({
  teamId,
  ...payload
}) => {
  let url = `/v1/alerts/ui-preferences/policies`;
  if (teamId) {
    url = `${url}?teamId=${teamId}`;
  }
  return fetch(url, {
    method: 'PATCH',
    body: payload,
    responseType: 'headers'
  });
};
export const changePolicyOrderEndpoint = payload => {
  return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
    method: 'PATCH',
    body: {
      after: payload.after
    },
    responseType: 'headers'
  });
};
export const enablePolicyEndpoint = payload => {
  return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
    method: 'POST',
    responseType: 'headers'
  });
};
export const disablePolicyEndpoint = payload => {
  return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
    method: 'POST',
    responseType: 'headers'
  });
};
export const deletePolicyEndpoint = payload => {
  return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
    method: 'DELETE',
    responseType: 'headers'
  });
};
export const createPolicyEndpoint = payload => {
  return fetch(`/v1/teams/${payload.teamId}/policies`, {
    method: 'POST',
    body: payload
  });
};
export const updatePolicyEndpoint = payload => {
  return fetch(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
    method: 'PUT',
    body: payload
  });
};